import { render, staticRenderFns } from "./ExamsDataTable.vue?vue&type=template&id=6d3ef060&scoped=true"
import script from "./ExamsDataTable.vue?vue&type=script&lang=js"
export * from "./ExamsDataTable.vue?vue&type=script&lang=js"
import style0 from "./ExamsDataTable.vue?vue&type=style&index=0&id=6d3ef060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3ef060",
  null
  
)

export default component.exports